<div class="flight-date-picker">
  <mach-date-picker
    [singleMonthView]="false"
    [singleDateSelection]="selectedTripType !== tripTypeOptions.ROUND_TRIP"
    [selectedRange]="selectedRange"
    [startDate]="datepickerConfig.startDate"
    [endDate]="datepickerConfig.endDate"
    [error]="
      fieldErrorInfo ? fieldErrorInfo : { errMessage: '', status: false }
    "
    [idpErrorState]="fieldErrorInfo ? fieldErrorInfo.status : false"
    (action)="onDateSelectionChange($event)"
    (clear)="onDateSelectionClear()"
    (opened)="isDatePickerOpen = $event"
  >
    <div ref>
      <div
        class="date-picker-btn-container"
        [tabIndex]="0"
        [ngClass]="{ 'date-picker-error': fieldErrorInfo?.status }"
      >
        <div class="date-picker-placeholder-container">
          <div class="date-picker-calendar-icon"></div>
          <div class="date-picker-placeholder-text">
            <span
              class="sr-only"
              [attr.aria-label]="
                getAriaLabelSelectedDate(
                  bookWidgetAem.datesField.datesAriaLabel
                )
              "
            ></span>
            <span aria-hidden="true">{{ getSelectedDate() }}</span>
          </div>
        </div>

        <div
          class="date-picker-caret-icon"
          [ngClass]="{ 'is-open': isDatePickerOpen }"
        ></div>
      </div>
    </div>
  </mach-date-picker>
</div>
